import { ITab } from 'constants/costRevModels';

export interface ISort {
    id: string,
    desc: boolean
}
export const SEARCH_TYPES = {
    GENERAL: 'General',
    BOOKING: 'Booking',
    FCR: 'FCR',
    CBL: 'CBL',
    EQUIPMENT: 'EquipmentClr',
    ETS: 'ETS',
    EXPORTJOB: 'EXPORTJOB'
}
export const SEARCH_TABS = (isExtraDocumentFeatureEnabled = false, isHblConsumptionEnabled = false): ITab[] => {
    return [
        {
            id: 1,
            title: 'General',
            emptyLabel: ''
        },
        {
            id: 2,
            title: 'Booking',
            emptyLabel: ''
        },
        {
            id: 3,
            title: isHblConsumptionEnabled ? 'FCR/HBL' : 'FCR',
            emptyLabel: ''
        },
        {
            id: 4,
            title: 'CBL',
            emptyLabel: ''
        },
        {
            id: 5,
            title: 'EQUIPMENT/CLR',
            emptyLabel: ''
        },
        {
            id: 6,
            title: 'ETS',
            emptyLabel: ''
        },
        {
            id: 7,
            title: 'CUSTOMER INVOICES',
            emptyLabel: ''
        },
        {
            id: 8,
            title: 'EXPORT JOB',
            emptyLabel: ''
        }
    ];
}

export const SEARCH_TABS_RESULT = (isHblConsumptionEnabled = false): ITab[] => {

    return [
        {
            id: 1,
            title: 'All',
            emptyLabel: ''
        },
        {
            id: 2,
            title: 'Booking',
            emptyLabel: ''
        },
        {
            id: 3,
            title: isHblConsumptionEnabled ? 'FCR/HBL' : 'FCR',
            emptyLabel: ''
        },
        {
            id: 4,
            title: 'CBL',
            emptyLabel: ''
        },
        {
            id: 5,
            title: 'EQUIPMENT/CLR',
            emptyLabel: ''
        }
    ];
}
export const searchRoutes = (id: number) => {
    switch (id) {
        case 2:
            return '/booking'
            break;
        case 3:
            return '/documents'
            break;
        case 4:
            return '/cbl'
            break;
        case 5:
            return '/equipment'
            break;
        case 6:
            return '/ets'
            break;
        case 7:
            return '/customer-invoices'
            break;
        case 8:
            return '/exportJobs'
            break;
    }
    return '/'
}
export const bookingCols = [{
    headerClassName: 'data-table header fixedNumber',
    className: 'fixedNumber',
    show: true,
    accessor: 'documentNumber',
    isActionLink: true,
    id: 'bookingNumber-col-link',
    fieldHeader: 'Booking number',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'originSiteCode',
    id: 'originSiteCode-col',
    fieldHeader: 'Origin Service',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'loadingPortCode',
    id: 'loadingPortCode-col',
    fieldHeader: 'Port of Loading',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'dischargePortCode',
    id: 'dischargePortCode-col',
    fieldHeader: 'Port of Discharge',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'destinationSiteCode',
    id: 'destinationSiteCode-col',
    fieldHeader: 'Destination Service',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'status',
    id: 'status-col',
    fieldHeader: 'Status',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'createDate',
    id: 'createDate-col',
    fieldHeader: 'Create Date',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangedBy',
    id: 'lastChangedBy-col',
    fieldHeader: 'Last Update By',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangeDate',
    id: 'lastChangeDate-col',
    fieldHeader: 'Update Date',
    sortable: true
}, {
    headerClassName: 'data-table header',
    show: true,
    accessor: 'id',
    fieldHeader: 'Booking ID',
    sortable: true
}]
export const FCRCols = (isHblConsumptionEnabled = false) => [
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'documentNumber',
        isActionLink: true,
        id: 'fcrNumber-col-link',
        fieldHeader: isHblConsumptionEnabled ? 'FCR/HBL number' : 'FCR number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'status',
        id: 'status-col',
        fieldHeader: 'Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'finOpsStatus',
        id: 'finOpsStatus-col',
        fieldHeader: 'FinOps Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sapsoNumber',
        id: 'sapsoNumber-col',
        fieldHeader: 'SAP SO Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'origin',
        id: 'origin-col',
        fieldHeader: 'Origin Service',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'destination',
        id: 'destination-col',
        fieldHeader: 'Destination Service',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consginee',
        id: 'consignee-col',
        fieldHeader: 'Consignee',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'shipper',
        id: 'shipper-col',
        fieldHeader: 'Shipper',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etd',
        id: 'etd-col',
        fieldHeader: 'ETD',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'eta',
        id: 'eta-col',
        fieldHeader: 'ETA',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangedBy',
        id: 'lastChangedBy-col',
        fieldHeader: 'Last Changed By',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangeDate',
        id: 'lastChangeDate-col',
        fieldHeader: 'Last Change Date',
        sortable: true
    }, {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: isHblConsumptionEnabled ? 'FCR/HBL ID' : 'FCR ID',
        sortable: true
    }]
export const CBLCols = [
    {
        headerClassName: 'data-table header fixedNumber',
        className: 'fixedNumber',
        show: true,
        accessor: 'documentNumber',
        isActionLink: true,
        id: 'cblNumber-col-link',
        fieldHeader: 'CBL number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'status',
        id: 'status-col',
        fieldHeader: 'Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'carrier',
        id: 'carrier-col',
        fieldHeader: 'Carrier Code',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'carrierBooking',
        id: 'carrierBooking-col',
        fieldHeader: 'Carrier Booking Reference',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'loadingPortCode',
        id: 'loadingPortCode-col',
        fieldHeader: 'Port of Loading',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'dischargePortCode',
        id: 'dischargePortCode-col',
        fieldHeader: 'Port of Discharge',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consginee',
        id: 'consignee-col',
        fieldHeader: 'Consignee',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'shipper',
        id: 'shipper-col',
        fieldHeader: 'Shipper',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etd',
        id: 'etd-col',
        fieldHeader: 'ETD',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'eta',
        id: 'eta-col',
        fieldHeader: 'ETA',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangedBy',
        id: 'lastChangedBy-col',
        fieldHeader: 'Last Changed By',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangeDate',
        id: 'lastChangeDate-col',
        fieldHeader: 'Last Change Date',
        sortable: true
    }, {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: 'CBL ID',
        sortable: true
    }]

export const EquipmentCols = [
    {
        headerClassName: 'data-table header fixedNumber-xxl',
        className: 'fixedNumber-xxl',
        show: true,
        accessor: 'documentNumber',
        isActionLink: true,
        id: 'equipmentNumber-col-link',
        fieldHeader: 'Equipment/CLR number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'status',
        id: 'status-col',
        fieldHeader: 'Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'size',
        id: 'size-col',
        fieldHeader: 'Size',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'type',
        id: 'type-col',
        fieldHeader: 'Type',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sealNumber1',
        fieldHeader: 'Seal Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'carrier',
        id: 'carrier-col',
        fieldHeader: 'Carrier Code',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'carrierBooking',
        id: 'carrierBooking-col',
        fieldHeader: 'Carrier Booking',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etsNumber',
        id: 'etsNumber-col',
        fieldHeader: 'ETS Number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'placeOfReceiptCode',
        id: 'placeOfReceiptCode-col',
        fieldHeader: 'Place of Receipt',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'loadingPortCode',
        id: 'loadingPortCode-col',
        fieldHeader: 'Port of Loading',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'dischargePortCode',
        id: 'dischargePortCode-col',
        fieldHeader: 'Port of Discharge',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'placeOfDeliveryCode',
        id: 'placeOfDeliveryCode-col',
        fieldHeader: 'Place of Delivery',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consginee',
        id: 'consignee-col',
        fieldHeader: 'Consignee',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etd',
        id: 'etd-col',
        fieldHeader: 'ETD',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'eta',
        id: 'eta-col',
        fieldHeader: 'ETA',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangedBy',
        id: 'lastChangedBy-col',
        fieldHeader: 'Last Changed By',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangeDate',
        id: 'lastChangeDate-col',
        fieldHeader: 'Last Change Date',
        sortable: true
    }, {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: 'ID',
        sortable: true
    }]
export const GeneralCols = [
    {
        headerClassName: 'data-table header fixedNumber-xxl',
        className: 'fixedNumber-xxl',
        show: true,
        accessor: 'documentNumber',
        isActionLink: true,
        id: 'referenceNumber-col-link',
        fieldHeader: 'Reference number',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'documentType',
        id: 'documentType-col',
        fieldHeader: 'Document Type',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'status',
        id: 'status-col',
        fieldHeader: 'Status',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'consginee',
        id: 'consignee-col',
        fieldHeader: 'Consignee',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'origin',
        id: 'origin-col',
        fieldHeader: 'Origin Service',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'destination',
        id: 'origin-col',
        fieldHeader: 'Destination Service',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'loadingPortCode',
        id: 'loadingPortCode-col',
        fieldHeader: 'Port of Loading',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'dischargePortCode',
        id: 'dischargePortCode-col',
        fieldHeader: 'Port of Discharge',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'etd',
        id: 'etd-col',
        fieldHeader: 'ETD',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'eta',
        id: 'eta-col',
        fieldHeader: 'ETA',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangedBy',
        id: 'lastChangedBy-col',
        fieldHeader: 'Last Changed By',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'lastChangeDate',
        id: 'lastChangeDate-col',
        fieldHeader: 'Last Change Date',
        sortable: true
    },
    {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'sealNumber1',
        fieldHeader: 'Seal Number',
        sortable: true
    }, {
        headerClassName: 'data-table header',
        show: true,
        accessor: 'id',
        fieldHeader: 'ID',
        sortable: true
    }]